import { getRemovedQueryParams } from './getRemovedQueryParams';
import { takePendingEmptyStateTracking, TPendingEmptyStateTracking } from './pendingEmptyStateTracking';
import { trackAllTagsClear, trackTagsClear } from './trackEmptyStateTags';

/**
 * Вытаскивает строку запроса из ссылки на выдачу. Так же её достаёт из меты
 * микрофронт фильтров, когда собирает лейбл для своих тегов.
 */
function getQueryStringFromUrl(url: string): string {
  const queryStringIndex = url.indexOf('?');

  return queryStringIndex === -1 ? '' : url.substring(queryStringIndex + 1);
}

/**
 * Отправляет отложенную аналитику по тегам блока пустой выдачи.
 *
 * Лейблом события должны быть снятые параметры запроса, поэтому новую строку запроса берём
 * из меты, которую приносит событие `filters:updated`: дожидаться перезапроса выдачи нельзя —
 * при смене субдомена он уводит на другую страницу, и событие не успело бы уйти.
 *
 * Если кликов по тегам не было, ничего не отправляет. Возвращает отложенное действие, чтобы
 * вызывающий код мог посчитать телеметрию по тому же клику.
 *
 * @param url ссылка на новую выдачу с применёнными фильтрами — `fullUrlWithoutSeo` из меты.
 * Сеошная ссылка не подходит: она прячет фильтры и не содержит строки запроса.
 */
export function trackPendingEmptyStateTags(url: string): TPendingEmptyStateTracking | null {
  const pendingTracking = takePendingEmptyStateTracking();

  if (!pendingTracking) {
    return null;
  }

  const label = getRemovedQueryParams(pendingTracking.queryString, getQueryStringFromUrl(url));

  if (pendingTracking.action === 'clearAllTags') {
    trackAllTagsClear(label);
  } else {
    trackTagsClear(label, pendingTracking.count);
  }

  return pendingTracking;
}
